import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { ObservationDefinitionEditComponent } from 'app/mdm/terminology/observation-definition/containers/observation-definition-edit.component';
import { ObservationDefinitionService } from 'app/mdm/lib/observation-definition/services/observation-definition.service';
import { ObservationDefinitionListComponent } from 'app/mdm/terminology/observation-definition/containers/observation-definition-list.component';
import { ObservationDefinitionIntervalsTableComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-intervals-table.component';
import { ObservationDefinitionIdentifiersTableComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-identifiers-table.component';
import { ObservationDefinitionTargetsTableComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-targets-table.component';
import { MdmLibModule } from 'app/mdm/lib/mdm-lib.module';
import { ObservationDefinitionTestComponent } from 'app/mdm/terminology/observation-definition/containers/test/observation-definition-test.component';
import { ObservationDefinitionReferencesTableComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-references-table.component';
import { ObservationDefinitionDataSettingsComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-data-settings.component';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { ObservationDefinitionRangeHintComponent } from 'app/mdm/terminology/observation-definition/containers/components/observation-definition-range-hint.component';
import { ObservationDefinitionLibModule } from 'app/mdm/lib/observation-definition/observation-definition-lib.module';
import { DataInputModule } from 'app/data-input/lib/data-input.module';

export const OD_ROUTES: Routes = [
  { path: '', component: ObservationDefinitionListComponent },
  { path: 'add', component: ObservationDefinitionEditComponent },
  { path: 'edit/:definitionId', component: ObservationDefinitionEditComponent },
  { path: 'test', component: ObservationDefinitionTestComponent },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    TerminologyLibModule,
    ObservationDefinitionLibModule,
    ReactiveFormsModule,
    MdmLibModule,
    DataInputModule,
  ],
  declarations: [
    ObservationDefinitionEditComponent,
    ObservationDefinitionListComponent,
    ObservationDefinitionIntervalsTableComponent,
    ObservationDefinitionIdentifiersTableComponent,
    ObservationDefinitionTargetsTableComponent,
    ObservationDefinitionTestComponent,
    ObservationDefinitionReferencesTableComponent,
    ObservationDefinitionDataSettingsComponent,
    ObservationDefinitionRangeHintComponent,
  ],
  providers: [ObservationDefinitionService],
})
export class ObservationDefinitionModule {}
